import { useState } from "react";
import { QuestionCircle } from "react-bootstrap-icons";
import "./Upload.css";

/**
 * HelpTooltip
 *
 * Props:
 *   text  {string}  — the tooltip message to display
 *   size  {number}  — icon size (default 13)
 */
export function HelpToolTip(props) {
  const text = props.text;
  const size = props.size || 13;

  const [visible, setVisible] = useState(false);

  return (
    <span className="help-tooltip">
      <button
        type="button"
        className="help-tooltip__trigger"
        onMouseEnter={function () {
          setVisible(true);
        }}
        onMouseLeave={function () {
          setVisible(false);
        }}
        onFocus={function () {
          setVisible(true);
        }}
        onBlur={function () {
          setVisible(false);
        }}
        aria-label="Help"
      >
        <QuestionCircle size={size} />
      </button>

      {visible && (
        <span className="help-tooltip__bubble" role="tooltip">
          {text}
        </span>
      )}
    </span>
  );
}
